import { FlexCol, FlexRow } from '@components'
import { useTranslation } from 'react-i18next'
import { BaseText } from '../BaseText'
import { DataCompletenessDot } from './DataCompletenessDot'
import type { DataCompletenessScope } from './dataCompleteness.mapper'
import {
  type IDataCompletenessItem,
  completenessIndicatorLayout,
  formatDataCompletenessPercentage,
  getDataCompletenessType,
  getDotsColumnGap,
  getNoMetersForScopeTranslationKey,
} from './dataCompletenessIndicator.utils'

interface DataCompletenessItemProps {
  item: IDataCompletenessItem
  scope: DataCompletenessScope
}

export const DataCompletenessItem = ({ item, scope }: DataCompletenessItemProps) => {
  const { t } = useTranslation()
  const { title, completenessPercentage, data } = item

  return (
    <FlexCol gap={'2px'} py={'4px'}>
      <FlexRow alignItems={'flex-start'} justifyContent={'space-between'} gap={'8px'}>
        <FlexCol>
          <BaseText flex={'1'} minWidth={0} fontSize={'14px'} color={'foreground'}>
            {title}
          </BaseText>
          {completenessPercentage == null && (
            <BaseText flex={'1'} minWidth={0} fontSize={'12px'} color={'secondaryForeground'}>
              {t(getNoMetersForScopeTranslationKey(scope))}
            </BaseText>
          )}
        </FlexCol>
        <BaseText flexShrink={0} whiteSpace={'nowrap'} fontSize={'14px'} color={'foreground'}>
          {completenessPercentage == null ? '-' : `${formatDataCompletenessPercentage(completenessPercentage)} %`}
        </BaseText>
      </FlexRow>
      {data?.length && (
        <FlexRow
          alignItems={'center'}
          justifyContent={'flex-start'}
          rowGap={`${completenessIndicatorLayout.dotRowGapPx}px`}
          columnGap={`${getDotsColumnGap(data.length)}px`}
          flexWrap={'wrap'}
          width={'100%'}
        >
          {data.map((dataPoint, index) => (
            <DataCompletenessDot key={`${index}-${dataPoint.startTime}`} type={getDataCompletenessType(dataPoint.completenessPercentage)} />
          ))}
        </FlexRow>
      )}
    </FlexCol>
  )
}
